/**
 * Which Things the Gateways list leaves out. An import makes a Thing for each data source it writes readings under
 * (platform-core/internal/twin/import_ingest.go: importSourceProduct), so its readings have a device. That Thing is
 * no gateway: it connects nothing, never reports, and read "Unknown" in the list (the walk of 2026-09-26, 13 of a
 * plant's file imports). Its data shows under Data sources. Pure.
 */

/** The product the platform gives an import's source Thing (importSourceProduct). */
export const FILE_IMPORT_SOURCE_PRODUCT = "file-import-source";

export function isFileImportSource(thing: { productId?: string | null }): boolean {
  return thing.productId === FILE_IMPORT_SOURCE_PRODUCT;
}

/**
 * Whether the plant's data comes from files alone, as the Gateways list sees it: an import's source Thing is there and
 * the list holds no gateway at all. The page then says "No gateways" with "This plant's data comes from files." in place of
 * an empty table (the 2026-10-24 page sweep, G3). Any gateway keeps the list, one not yet connected among them (it
 * reads "unknown" until its first message), so a gateway just added or claimed can always be opened (the #1641 review,
 * I2). Pure.
 */
export function gatewaysFromFilesOnly(
  things: readonly { productId?: string | null }[],
  gateways: readonly unknown[],
): boolean {
  return things.some(isFileImportSource) && gateways.length === 0;
}
